import React, {createContext, useState} from 'react'

export const UsuarioContext = createContext()

const UsuarioProvider = (props) => {
  const usuarioTipo = {
    nombres: '',
    apellidos: '',
    rut: '',
    numserie:'',
    email: '',
    celular: '',
    direccion: '',    
    paso:1,
    token:'',
    selectedEnabledPlan:'1AFAO',
    selectedEnabledEmpresa:false,
    pin:'',
    esNotario:false,
    codNotario:'',
    codDescuento:'',
    descuentoAplicado:'',
    tieneToken:false,
    b64:'',
    cienviado:false
  }
  const dataEmpresaTipo = {
    rut:'',
    razonSocial:'',
    actividadEconomica: '',
    email:'',
    telefono:'',
    direccion:'',
    actividadEconomicaError:false
  }   
  const [planUser, setplanUser] = useState("")
  const [usuario, setusuario] = useState(usuarioTipo)
  const [dataEmpresa, setdataEmpresa] = useState(dataEmpresaTipo)
  const [question, setquestion] = useState(null)
  const [signupModalPin, setSignupModalPin] = useState({mensaje:'',open:false,modificarData:false})
 
  return (
    
        <UsuarioContext.Provider value={{usuario, setusuario, dataEmpresa, setdataEmpresa, question, setquestion, signupModalPin, setSignupModalPin,planUser, setplanUser}} >
        {props.children}
      </UsuarioContext.Provider>
  )
}

export default UsuarioProvider